import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import TokenService from '../services/TokenService'
import Grid from '@mui/material/Grid';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AlertDialog from './Modals/AlertDialog'
import DoneIcon from '@mui/icons-material/Done';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import Profile from './MyAccount/Profile';
import Preferences from './MyAccount/Preferences';
import ServiceAreas from './MyAccount/ServiceAreas';
import cloneDeep from 'lodash/cloneDeep';
import TrainingItemsIndicator from './Training/TrainingItemsIndicator.jsx';
import AllTrainingCompleted from './Modals/AllTrainingCompleted.jsx';
import Button from '@mui/material/Button';

function MyAccount() {
    const [isFetching, setIsFetching] = useState(true);
    const documentLoaded = useRef(false);
    const [userLevel, setUserLevel] = useState(null);
    const prevUserLevel = useRef(false);
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const [alertDialog, setAlertDialog] = useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });
    const [loggedInUser, setLoggedInUser] = useState(null);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [allTrainingCompleted, setAllTrainingCompleted] = useState(false);

    useEffect(() => {
        loadAccount(); // only called once
    }, []);

    function loadAccount() {
        //if (sessionStorage.getItem('LoggedInUser') != null) {
        //    setLoggedInUser(JSON.parse(sessionStorage.getItem('LoggedInUser')));
        //    setIsFetching(false);
        //}
        //else {
           
        //}
        if (documentLoaded.current == false) {
            TokenService.post('', 'Returner_MyAccount')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        if (typeof jsonData === 'string') {
                            jsonData = JSON.parse(jsonData);
                        }
                        let returnerData = jsonData.ReturnerData;
                        if (typeof returnerData === 'string') {
                            returnerData = JSON.parse(returnerData);
                        }
                        let level = JSON.parse(jsonData.ReturnerLevel);
                        setLoggedInUser(returnerData);
                        setUserLevel(level);
                        prevUserLevel.current = level;
                        sessionStorage.setItem('LoggedInUser', JSON.stringify(returnerData));
                        setIsFetching(false);
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                }); 
            document.getElementsByTagName('body')[0].addEventListener('ReturnerLevel_Updated', (event) => handleUserLevelUpdated(event));
            documentLoaded.current = true;
        }

    }

    function handleUserLevelUpdated(event) {
        if (event != null) {
            let level = event.detail;
            if (prevUserLevel.current != null) { 
                if (prevUserLevel.current.TrainingChecklist.RemainingItemCount > 0 &&
                    level.TrainingChecklist.RemainingItemCount == 0) {
                    setAllTrainingCompleted(true);
                }
            }
            prevUserLevel.current = level;
            setUserLevel(level);
        }
    }

    function propsChanged(updatedUser) {
        let clonedUser = cloneDeep(updatedUser); // deep clone so the reference is updated and setLoggedInUser re-renders
        sessionStorage.setItem('LoggedInUser', JSON.stringify(updatedUser));
        setLoggedInUser(clonedUser);
    }

    function showMoreInfo(infoType) {
        if (infoType == 'Photo') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>Why do I need a photo?</div>
                            <div style={{ marginTop: '10px', fontWeight: 'bold' }}>#1 Safety </div>
                            <div>You will be picking up from people's homes. They will be able to see this photo prior to your arrival.</div>
                            <div style={{ marginTop: '10px', fontWeight: 'bold' }}>#2 Professionalism </div>
                            <div>This adds a level of class to your service.</div>

                            <div style={{ marginTop: '10px', backgroundColor: 'black', height: '2px', width: '100%' }}></div>

                            <div style={{ marginTop: '10px', fontWeight: 'bold' }}>Photo Tips </div>
                            <div style={{ display: 'flex' }}><DoneIcon style={{ alignSelf: 'center' }} /> <div style={{ alignSelf: 'center' }} >No hats or sunglasses (eyeglasses and religious garments are accepted)</div></div>
                            <div style={{ display: 'flex' }}><DoneIcon style={{ alignSelf: 'center' }} /> <div style={{ alignSelf: 'center' }} >Full face and top of shoulders</div></div>
                            <div style={{ display: 'flex' }}><DoneIcon style={{ alignSelf: 'center' }} /> <div style={{ alignSelf: 'center' }} >Good lighting</div></div>
                            <div style={{ display: 'flex' }}><DoneIcon style={{ alignSelf: 'center' }} /> <div style={{ alignSelf: 'center' }} >Not blurry</div></div>
                            <div style={{ display: 'flex' }}><DoneIcon style={{ alignSelf: 'center' }} /> <div style={{ alignSelf: 'center' }} >Only one person in the picture</div></div>
                            <div style={{ display: 'flex' }}><DoneIcon style={{ alignSelf: 'center' }} /> <div style={{ alignSelf: 'center' }} >Face is centered in the frame</div></div>
                            <div style={{ display: 'flex' }}><DoneIcon style={{ alignSelf: 'center' }} /> <div style={{ alignSelf: 'center' }} >If you are able, use a solid background.</div></div>
                            <div style={{ display: 'flex' }}><SentimentVerySatisfiedIcon style={{ alignSelf: 'center' }} /> <div style={{ alignSelf: 'center' }} >Smile!</div></div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
        
    }

    


    return (
        <>
            
            {userLevel == null || userLevel == undefined ? null :
                <TrainingItemsIndicator ShowIndicator={true} TrainingChecklist={userLevel.TrainingChecklist} />
            }
                
            
            <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', flexWrap: 'wrap' }}>


                <Profile showMoreInfo={(infoType) => showMoreInfo(infoType)} loggedInUser={loggedInUser} onChange={propsChanged} />


                <Preferences showMoreInfo={(infoType) => showMoreInfo(infoType)} loggedInUser={loggedInUser} onChange={propsChanged} />

                <ServiceAreas showMoreInfo={(infoType) => showMoreInfo(infoType)} loggedInUser={loggedInUser} onChange={propsChanged} />

                <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} CloseText={alertDialog.closeButton} />


            </div>
            {allTrainingCompleted ?
                <AllTrainingCompleted onClose={() => setAllTrainingCompleted(false)} />
                :
                null
            }
        </>
    );
}

export default MyAccount;